import React, { useContext } from 'react';
import { WebTagContext } from '../../context/WebTagContext';

export const WebTagSuccess = ({ transaction }) => {
    const { step, 
        userData, 
        tagCar, 
        error,
        loading,
        setStep, 
        setUserData,
        setTagCar,
        setError,
        setTransaction } = useContext(WebTagContext);
    const handleClickNew = () => {
        setUserData( {
            documentType: '',
            document: '',
            name1: '',
            name2: '',
            lastName1: '',
            lastName2: '',
            dob: '',
            sex: '',
            phone: '',
            cellphone: '',
            email: ''
        } );
        setTagCar( {
            tag: '',
            carRegistration: '',
            brand: '',
            brandModel: '',
            color: '',
            carYear: ''
        } );
        setStep({
            current: 1
        });
    }

    return (
        <>
            <div className="step">
                <div className="step-container">
                    <h3 className="title">¡Su solicitud se agregó con éxito! <small>Número: { transaction }</small></h3>
                    <p>{ '1) Su Solicitud de ALTA de TAG está PENDIENTE de aprobación.' }</p>
                    <p>{ '2) Para finalizar el trámite de adhesión Uds. deberá asociar el TAG con un medio de pago valido (ej. TARJETA de CREDITO).' }</p>
                    <p>{ '3) Para ello deberá dirigirse a Oficina de Estacionamiento Americano para realizar tramite y firmar contrato de adhesión.' }</p>
                    <p>{ '4) Hasta tanto no haya firmado el contrato de adhesión, no podrá usar el mismo en el PARKING del SEGURO AMERICANO.' }</p>
                </div>
            </div>
            <div className="no-margin step-actions">
                <button 
                    type = "button"
                    className="btn-form"
                    onClick = { handleClickNew }>
                        Añadir nueva
                </button>
            </div>
        </>
    );
}
